/* eslint-disable no-undef */
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
// Core components
import Avatar from 'components/core/Avatar';
import Divider from 'components/core/Divider';
// Custom
import mProduct from 'models/product';
import AppIcon from 'components/icons/AppIcon';
import OpacFooter from 'components/footer/OpacFooter';

let MainViewFooter;
switch (__PRODUCT__) {
  case mProduct.getOpacValue:
    MainViewFooter = <OpacFooter />;
    break;
  default:
    MainViewFooter = null;
}

const MainViewTemplate = ({
  title,
  icon,
  buttons,
  children,
  withPadding,
  withDivider,
  contentMaxWidth,
}) => (
  <React.Fragment>
    <div className="p-2 w-100" style={{ maxWidth: contentMaxWidth }}>
      {title && (
      <div className="box box-transparent mb-0">
        <div className="box-header box-title-big p-0 pt-3 px-2 px-md-4">
          <div className="d-flex flex-nowrap justify-content-between align-items-center w-100">
            <div className="d-flex align-items-center">
              {icon && __PRODUCT__ === mProduct.getOpacValue && (
              <div className="mr-2">
                <Avatar primary>
                  <AppIcon id={icon} />
                </Avatar>
              </div>
              )}
              <span className="title">
                {title}
              </span>
            </div>
            <div className="d-flex flex-wrap align-items-center justify-content-end hidden-xs-down right-spaced-buttons">
              { buttons }
            </div>
          </div>
          <div className="d-flex flex-wrap justify-content-end hidden-sm-up">
            { buttons }
          </div>
          <div className="pt-3">
            {withDivider && (
              <Divider light />
            )}
          </div>
        </div>
      </div>
      )}
      <div
        className={
        classnames('px-0 w-100', {
          'px-md-4': withPadding,
        })
      }
      >
        {children}
      </div>
    </div>
    {MainViewFooter}
  </React.Fragment>
);

MainViewTemplate.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  icon: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.element),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  withPadding: PropTypes.bool,
  withDivider: PropTypes.bool,
  contentMaxWidth: PropTypes.number,
};

MainViewTemplate.defaultProps = {
  title: null,
  icon: null,
  children: null,
  buttons: null,
  withPadding: false,
  withDivider: false,
  contentMaxWidth: null,
};

module.exports = MainViewTemplate;



// WEBPACK FOOTER //
// ./components/templates/MainViewTemplate.js